import { FC } from 'react';
import { Empty, Tabs } from 'antd';
import { BookingVariables } from './components/BookingVariables';

const Variables: FC = () => {
    const items = [
        {
            key: 'booking',
            label: 'Booking Variables',
            children: <BookingVariables />,
        },
        {
            key: 'mrr',
            label: 'MRR Variables',
            children: (
                <Empty description="No MRR variables for this plan" />
            ),
        },
    ];

    return (
        <Tabs
            defaultActiveKey="booking"
            items={items}
        />
    );
};

export { Variables };
